{
  "header": {
    "title": "Manage organization",
    "not_registered": "Not registered",
    "tab_users": "Users",
    "tab_departments": "Departments"
  },
  "users": {
    "action_add": {
      "success": "User invited successfully",
      "label": "Invite user",
      "title": "Invite user",
      "forbidden": "Insufficient privileges",
      "not_found": "User does not exist",
      "already_invited": "User has already been invited",
      "already_organization_member": "User is already in the organization",
      "form_action_Submit": "Invite",
      "action_label": "Invite {{count}} member",
      "action_label_plural": "Invite {{count}} members",
      "invite_by_email": "Enter email address"
    },
    "action_update_role": {
      "success": "User role changed successfully",
      "tooltip": "Edit User",
      "title": "Update user role",
      "content_text": "Updating role for {{email}}",
      "role_label": "Role",
      "forbidden": "Forbidden action",
      "not_found": "User not found",
      "role_already_assigned": "Role already assigned",
      "no_owners_left": "There must be at least one owner remaining",
      "validation_role": "User role is required"
    },
    "action_delete": {
      "success": "User removed successfully",
      "tooltip": "Remove user",
      "title": "Remove user",
      "content_text": "Are you sure that you want to remove {{email}} from the organization?",
      "error_forbidden": "Forbidden action",
      "error_not_found": "User not found",
      "error_no_owners_left": "There must be at least one owner remaining",
      "form_action_Submit": "Remove"
    },
    "action_resolve_invite": {
      "success": "Invitation accepted successfully",
      "tooltip": "Resolve invite",
      "title": "Pending Invitation",
      "content_text": "Resolving Invite to: ",
      "content_text_Accept": "You are accepting!",
      "content_text_Reject": "You are rejecting the invitation!",
      "error_not_found": "User not found",
      "error_submit": "An error has occurred: Your invitation cannot be resolved",
      "form_accept_action": "Accept",
      "form_dismiss_action": "Dismiss"
    }
  },
  "management": {
    "manage_organization": "Manage organization",
    "details_tab": "Details",
    "projects_tab": "Projects",
    "clusters_tab": "Clusters",
    "members_tab": "Members",
    "teams_tab": "Teams",
    "sso_tab": "SSO",
    "details_section": {
      "general_title": "General",
      "location_title": "Location",
      "unsaved_form_question": "Your changes are not saved. Are you sure?"
    },
    "projects_list": {
      "title_projects": "Project",
      "title_services": "Services",
      "title_created": "Date created",
      "no_projects": "There are not projects",
      "create": "+ Create New"
    },
    "clusters_list": {
      "title_cluster": "Cluster",
      "title_service": "Service",
      "title_status": "Status",
      "title_project": "Project",
      "no_clusters": "There are not clusters",
      "create": "+ Create New",
      "choose_cluster": "Which cluster do you want to create?"
    },
    "members_list": {
      "you": "You",
      "title_members": "Members",
      "title_role": "Role",
      "title_authentication": "Authentication",
      "add": "+ Invite members",
      "title_invited": "Invited",
      "title_expires_in": "Expires in",
      "no_invited_users": "There are no invited users",
      "no_members": "There are no members",
      "modal_title": "Invite Members",
      "cancel_invite": "Cancel",
      "expires_status_permanent": "Permanent",
      "authentication": {
        "basic_auth": "Username & Password",
        "oauth2": "OAuth 2.0",
        "oidc": "OIDC",
        "part_of_sso_groups": "This user is a member of the following SSO groups:"
      }
    }
  },
  "organizations": {
    "action_delete_thumbnail": {
      "content_text": "Are you sure that you want to delete the organization thumbnail?"
    }
  },
  "departments": {
    "projects": "Project",
    "projects_plural": "Projects",
    "no_projects": "No projects available",
    "your_projects": "Your projects",
    "action_add": {
      "success": "Department created successfully",
      "label": "Add Department",
      "title": "Add Department",
      "error_not_found": "Organization not found",
      "error_duplicate_name": "A department with this name already exists",
      "form_action_create": "Create"
    },
    "action_edit": {
      "success": "Department modified successfully",
      "tooltip": "Edit Department",
      "title": "Update user role"
    },
    "action_delete": {
      "success": "Department deleted successfully",
      "tooltip": "Delete Department",
      "title": "Delete user"
    },
    "action_delete_thumbnail": {
      "content_text": "Are you sure that you want to delete the department thumbnail?"
    },
    "products": {
      "total": "Total",
      "up": "Up",
      "down": "Down",
      "no_products_in_department": "This department does not have any products.",
      "no_products_in_project": "This project does not have any products.",
      "no_products_in_organization": "This organization does not have any products."
    },
    "management": {
      "manage_department": "Manage Department",
      "projects_tab": "Projects",
      "clusters_tab": "Clusters",
      "members_tab": "Members",
      "projects_list": {
        "title_projects": "Project",
        "title_author": "Created by",
        "title_created": "Date created",
        "no_projects": "There are not projects",
        "create": "+ Create New"
      },
      "clusters_list": {
        "title_cluster": "Cluster",
        "title_status": "Status",
        "title_project": "Project",
        "no_clusters": "There are not clusters"
      },
      "members_list": {
        "you": "You",
        "title_members": "Members",
        "no_members": "There are not members",
        "add": "+ Add members",
        "form": {
          "empty_list": "Member list is empty",
          "search": {
            "no_results": "Nothing was found"
          }
        }
      }
    }
  },
  "projects": {
    "action_delete_thumbnail": {
      "content_text": "Are you sure that you want to delete the project thumbnail?"
    },
    "management": {
      "manage_project": "Manage Project",
      "clusters_tab": "Clusters",
      "members_tab": "Members",
      "clusters_list": {
        "title_cluster": "Cluster",
        "title_type": "Service",
        "title_status": "Status",
        "no_clusters": "There are not clusters"
      },
      "members_list": {
        "title_members": "Members",
        "you": "You",
        "no_members": "This project does not have any members yet.",
        "form": {
          "empty_list": "Member list is empty",
          "search": {
            "no_results": "Nothing was found"
          }
        }
      }
    }
  },
  "teams": {
    "add_team": "Add team",
    "add_members": "Add users",
    "add_groups": "Add groups",
    "sso_group": "SSO group",
    "remove_member_part1": "Are you sure that you want to remove ",
    "remove_member_part2": " from the team?",
    "remove_team_part1": "Are you sure that you want to delete the ",
    "remove_team_part2": " team?",
    "remove_team_can_not_be_undone": "This action can not be undone.",
    "add_members_modal": {
      "submit": "Add {{count}} member",
      "submit_plural": "Add {{count}} members",
      "no_possible_members": "All organization users are already a member of this team.",
      "no_search_results": "Your search yielded no results."
    },
    "add_groups_modal": {
      "search_or_add": "Search or add a group",
      "submit": "Add {{count}} group",
      "submit_plural": "Add {{count}} groups",
      "no_possible_groups": "All known groups are already part of the team. To add a custom group, use the text field above.",
      "no_search_results": "Your search yielded no results. To add a custom group, press Enter or click the Plus icon.",
      "errors": {
        "already_exists": "That group already exists.",
        "already_member": "That group is already a member of the team."
      }
    },
    "table": {
      "number_of_teams": "{{count}} team",
      "number_of_teams_plural": "{{count}} teams",
      "number_of_members": "{{count}} member",
      "number_of_members_plural": "{{count}} members",
      "no_teams": "This organization doesn't have any teams yet.",
      "no_members": "This team doesn't have any members yet."
    },
    "properties": {
      "identifier": {
        "title": "Identifier",
        "immutable": "The identifier may not be changed.",
        "errors": {
          "required": "The identifier may not be empty.",
          "regex": "The identifier may only contain lowercase letters, - and _."
        }
      },
      "displayName": {
        "title": "Display Name",
        "errors": {
          "required": "The display name may not be empty.",
          "regex": "The display name may only contain letters, spaces, - and _."
        }
      },
      "about": {
        "title": "About",
        "empty_placeholder": "This team has no description."
      },
      "role": {
        "title": "Role"
      }
    }
  },
  "oidc": {
    "status": {
      "label": "Single Sign-On is currently <status>{{status}}</status>",
      "active": "enabled",
      "inactive": "disabled",
      "actions": {
        "activate": "Activate",
        "deactivate": "Deactivate",
        "confirm": "Are you sure you want to {{action}} Single Sign-On for your organization?"
      }
    },
    "hint": {
      "main": "Use the following values when registering your OIDC client with the identity provider:",
      "root_url": "Root URL: <b>{{url}}</b>",
      "origin_url": "Web Origin: <b>{{url}}</b>",
      "redirect_url": "Valid Redirect URI: <b>{{url}}</b>"
    },
    "teamMappingInfo": {
      "nothingSetUp": "It looks like you haven’t configured any teams for SSO integration yet.",
      "currentBehaviour": "At the moment, users logging in through your identity provider are added as basic organization members without access to any projects.",
      "listCTA": "To enable automatic team assignment and simplify user onboarding:",
      "listStep1": "Make sure your Identity Provider includes user groups in the token sent to Scalefield.",
      "listStep2": "Set the Group Claim Name to match the attribute used by your IdP for group information.",
      "listStep3": "Create a team in Scalefield and assign the appropriate SSO groups as members.",
      "afterBehaviour": "Users in those groups will be automatically assigned to the corresponding teams and inherit their permissions when they log in."
    },
    "properties": {
      "issuerUrl": {
        "title": "Issuer URL",
        "hint": "The base URL of your OpenID Provider. This should be the URL where <b>/.well-known/openid-configuration</b> is accessible (e.g., <b>https://accounts.example.com/realms/internal</b>).",
        "success": "The provided URL is valid.",
        "error": "The provided URL does not contain a valid OpenID Connect configuration. Ensure that <b>/.well-known/openid-configuration</b> is accessible and correctly set up."
      },
      "clientId": {
        "title": "Client ID",
        "hint": "The unique identifier assigned to Scalefield within your OpenID Provider."
      },
      "clientSecret": {
        "title": "Client Secret",
        "hint": "A confidential key issued by your OpenID Provider, used to authenticate Scalefield."
      },
      "verifyCertificate": {
        "title": "Verify Certificate",
        "hint": "Only disable this option if your provider is unable to offer secure communication (e.g., enforcing HTTPS and verifying TLS certificates)."
      },
      "groupAttribute": {
        "title": "Group Claim Name",
        "hint": "The name of the attribute in which the Identity Provider provides the groups the user belongs to."
      },
      "domains": {
        "title": "Associated domains",
        "hint": "A list of email domains (the part after <b>@</b>, e.g. <b>example.com</b>) that should use this OIDC configuration. When a user logs in, their email domain will be matched to determine the correct OIDC provider.",
        "field": "Domain",
        "actions": {
          "add": "Add domain",
          "remove": "Remove domain"
        }
      }
    }
  },
  "department_selected": "{{count}} department selected",
  "department_selected_plural": "{{count}} departments selected",
  "project_selected": "{{count}} project selected",
  "project_selected_plural": "{{count}} projects selected",
  "cluster_selected": "{{count}} Cluster selected",
  "cluster_selected_plural": "{{count}} Clusters selected"
}
